import axios from "axios";
import moment from "moment";
import rand from "randomstring";
import { encryptAES, decryptAES, signRSA } from "./encryption";
import { getEnvOnly } from "./Meet";
// import { Logtail } from "@logtail/browser";
import { StopWatch } from 'stopwatch-node';



let publicKey;
let LlaveAES;
let Token;
// const logtail = new Logtail("3egdE3x8gsYKyaWig9b7WaDq");
const MaxTimeout = 30000;

function getLlavePublica(Timeout) {
  const server = getEnvOnly()?.VUE_APP_HUELLA_FV_SERVER;
  if (publicKey) return publicKey;
  
  const sw = new StopWatch('sw');
  sw.start('sw');
  return axios
    .get(`${server}/login/llavepublica`, Timeout ? { timeout: MaxTimeout } : {})
    .then(data => data.data)
    .then(pub => {
      publicKey = pub;
      sw.stop();
      // logtail.info("request colmedica", {
      //   url: `${server}/login/llavepublica`,
      //   method: "GET",
      //   time: sw.getTask("sw")?.timeMills
      // });
      return pub;
    });
}

async function colmedicaDecode(encoded) {
  let ivString = encoded.substr(0, 16);
  let encodedString = encoded.substr(16);
  const decoded = await decryptAES(LlaveAES, ivString, encodedString);
  return decoded;
}

async function autorizar({
  // LF Tested OK 21-01-20
  TipoIdentificacion,
  NumeroIdentificacion,
  CodigoOficina,
  Timeout = false
}) {
  const keyString = rand.generate(32);
  const enc = await signRSA(await getLlavePublica(Timeout), {
    TipoIdentificacion,
    NumeroIdentificacion,
    CodigoOficina,
    Key: keyString
  });
  const server = getEnvOnly()?.VUE_APP_HUELLA_FV_SERVER;

  const sw = new StopWatch('sw');
  sw.start('sw');
  console.log("jas timeout:",  Timeout ? { timeout: MaxTimeout } : {})
  const { data } = await axios.post(`${server}/login/autorizar`, { mensaje: enc.Data }, Timeout ? { timeout: MaxTimeout } : {});
  sw.stop();
  // logtail.info("request colmedica", {
  //   url: `${server}/login/autorizar`,
  //   method: "POST",
  //   time: sw.getTask("sw")?.timeMills
  // });

  LlaveAES = keyString;

  let results = await colmedicaDecode(data);

  console.log("****Colmedica Decode***")
  console.log(results)
  
  results = JSON.parse(results);

  console.log("****JSON.parse - Colmedica Decode***")
  console.log(results)

  if (results.Resultado === 1) {
    Token = results.Token;
    LlaveAES = results.LlaveAes;
  } else {
    console.error("Invalid site auth", results);
    throw new Error("Invalid Authorization in Huella FV");
  }
}

async function enOficina(_timeout = false) {
  
  const sw = new StopWatch('sw');
  sw.start('sw');
  const server = getEnvOnly()?.VUE_APP_HUELLA_FV_SERVER;
  return axios
    .post(`${server}/cliente/oficina`, undefined, {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    },
    _timeout ? { timeout: MaxTimeout } : {})
    .then(data => {
      sw.stop();
      // logtail.info("request colmedica", {
      //   url: `${server}/cliente/oficina`,
      //   method: "GET",
      //   time: sw.getTask("sw")?.timeMills
      // });
      return data.data
    })
    .then(enc => colmedicaDecode(enc))
    .then(enc => JSON.parse(enc));
}

async function enCentroMedico(_timeout = false) {
  // LF Tested 21-01-21

  const sw = new StopWatch('sw');
  sw.start('sw');

  const server = getEnvOnly()?.VUE_APP_HUELLA_FV_SERVER;
  return axios
    .post(`${server}/cliente/centromedico`, undefined, {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    },
    _timeout ? { timeout: MaxTimeout } : {})
    .then(data => { 
      sw.stop();
      // logtail.info("request colmedica", {
      //   url: `${server}/cliente/centromedico`,
      //   method: "GET",
      //   time: sw.getTask("sw")?.timeMills
      // });
      return data.data
    })
    .then(enc => colmedicaDecode(enc))
    .then(enc => JSON.parse(enc));
}

async function citas(_timeout = false) {

  const sw = new StopWatch('sw');
  sw.start('sw');

  const server = getEnvOnly()?.VUE_APP_HUELLA_FV_SERVER;
  return axios
    .post(`${server}/cliente/citas`, undefined, {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    },
    _timeout ? { timeout: MaxTimeout } : {})
    .then(data => { 
      sw.stop();
      // logtail.info("request colmedica", {
      //   url: `${server}/cliente/citas`,
      //   method: "POST",
      //   time: sw.getTask("sw")?.timeMills
      // });
      return data.data
    })
    .then(enc => colmedicaDecode(enc))
    .then(enc => { console.log("CITAS", JSON.parse(enc)); return JSON.parse(enc) })
    .then(citas =>
      citas.map(cita => ({
        ...cita,
        idCita: cita.IdCita,
        Fecha: moment(cita.Fecha).format("YYYY-MM-DD h:mm a")
      }))
    );
}

async function validarPago({ idCita }) {
  const server = getEnvOnly()?.VUE_APP_HUELLA_FV_SERVER;
  const ivString = rand.generate(16);
  const encoded = await encryptAES(
    LlaveAES,
    ivString,
    JSON.stringify({
      idCita
    })
  );

  const sw = new StopWatch('sw');
  sw.start('sw');
  return axios
    .post(
      `${server}/cliente/validarpagocita`,
      {
        mensaje: encoded,
        iv: ivString
      },
      {
        headers: {
          Authorization: `Bearer ${Token}`
        }
      }
    )
    .then(data => { 
      sw.stop();
      // logtail.info("request colmedica", {
      //   url: `${server}/cliente/validarpagocita`,
      //   method: "POST",
      //   time: sw.getTask("sw")?.timeMills
      // });
      return data.data
    })
    .then(enc => colmedicaDecode(enc))
    .then(enc => JSON.parse(enc));
}

export { autorizar, enCentroMedico, enOficina, citas, validarPago };
